import React from 'react'

type BlobDownloader = (blob: Blob, filename?: string) => void

/**
 * This hook returns a function that will initiate a download for the provided blob.
 */
export function useBlobDownloader(): BlobDownloader {
  const download = React.useCallback<BlobDownloader>((blob: Blob, filename = '') => {
    const objectURL = URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = objectURL
    anchor.download = filename
    anchor.hidden = true
    document.body.appendChild(anchor)
    anchor.click()
    URL.revokeObjectURL(objectURL)
    document.body.removeChild(anchor)
  }, [])

  return download
}
